enum AnalyticsType {
    AgingBalance = 'AgingBalance',
    Bookings = 'Bookings',
    Manager = 'Manager',
    Financial = 'Financial',
    Outlet = 'Outlet',
    Pickup = 'Pickup',
    DepositLedger = 'DepositLedger',
    GuestLedger = 'GuestLedger',
    TrialBalance = 'TrialBalance',
    Marketing = 'Marketing',
    MultiPropertyMarketing = 'MultiPropertyMarketing',
}

export default AnalyticsType;
